import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import BlogList from "../../components/BlogList/BlogList.js";
import Footer from "../../components/footer/Footer.js";
import Scrollbar from "../../components/scrollbar/scrollbar";

const BlogPageLeft = () => {
  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-3"} />
      <PageTitle pageTitle={"Latest News"} pagesub={"Blog"} />
      <BlogList blLeft={"order-lg-1"} blRight={"order-lg-2"} />
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default BlogPageLeft;
